import { create } from 'zustand'
import { createSelectors } from '~/shared/lib/zustand-utils'
import { DEFAULT_PAGE_SIZE } from '../config'

interface PaginationStore {
  currentPage: number
  setCurrentPage: (page: number) => void
  evaluationKeysMap: Record<number, string | null>
  setEvaluationKeysMap: (evaluationKeysMap: Record<number, string | null>) => void
  visibleRowsCount: number
  setVisibleRowsCount: (count: number) => void
}

const paginationStore = createSelectors(
  create<PaginationStore>((set) => ({
    currentPage: 1,
    setCurrentPage: (page: number) => set({ currentPage: page }),
    evaluationKeysMap: { 1: null },
    setEvaluationKeysMap: (evaluationKeysMap: Record<number, string | null>) =>
      set({ evaluationKeysMap }),
    visibleRowsCount: DEFAULT_PAGE_SIZE,
    setVisibleRowsCount: (count: number) => set({ visibleRowsCount: count }),
  })),
)

export const usePaginationSelectors = ({ pageSize }: { pageSize: number }) => {
  const currentPage = paginationStore.use.currentPage()
  const setCurrentPage = paginationStore.use.setCurrentPage()
  const visibleRowsCount = paginationStore.use.visibleRowsCount()
  const evaluationKeysMap = paginationStore.use.evaluationKeysMap()
  const setEvaluationKeysMap = paginationStore.use.setEvaluationKeysMap()
  const setVisibleRowsCount = paginationStore.use.setVisibleRowsCount()

  const startRow = (currentPage - 1) * pageSize + 1

  const resetPagination = () => {
    setCurrentPage(1)
    setEvaluationKeysMap({ 1: null })
  }

  return {
    currentPage,
    setCurrentPage,
    evaluationKeysMap,
    setEvaluationKeysMap,
    visibleRowsCount,
    setVisibleRowsCount,
    hasPreviousPage: currentPage > 1,
    hasNextPage: !!evaluationKeysMap[currentPage + 1],
    startRow,
    endRow: startRow + visibleRowsCount - 1,
    resetPagination,
  }
}
